import { Component, ViewChild, OnInit, ElementRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QRCodeGenerator, BarcodeExportType } from '@syncfusion/ej2-barcode-generator';

@Component({
  selector: 'web-sim-qrcode',
  templateUrl: './qr-code-display.component.html'
})
export class QrCodeDisplayComponent implements OnInit {
  @Input() public deviceId = '000000000000';
  @Input() public devicePin = '0000';

  public targetElement: HTMLElement;
  public dialogVisible: boolean = false;

  private qrCodeImg: QRCodeGenerator; 


  constructor(
    private profileModal: NgbActiveModal) { }

  ngOnInit() {
      let txt = this.deviceId
      let qr = this.deviceId
      if (this.devicePin && this.devicePin.length > 0) {
        txt += ' PIN ' + this.devicePin;
        qr += ','+this.devicePin;
      }
    
      this.qrCodeImg = new QRCodeGenerator({
      width: '350px', height: '350px',
      value: qr,
      displayText: { text: txt },
      mode: 'SVG',
    });
    this.qrCodeImg.appendTo('#qrCode');
  }

  get activeModal() {
    return this.profileModal;
  }

  public Save() {       
    let qr = this.deviceId
    if (this.devicePin && this.devicePin.length > 0) {
      qr += ','+this.devicePin;
    }

    this.qrCodeImg.exportImage(qr, 'PNG');
  }
}